
export const messages = {
  en: {
    contractDetail: {
      title: 'Contract Information',
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      contractType: 'Contract Type',
      partyA: 'Party A',
      partyB: 'Party B',
      aContacts: 'Party A Contact',
      bContacts: 'Party B Contact',
      aLink: 'Party A Phone',
      bLink: 'Party B Phone',
      operator: 'Operator',
      operatorLink: 'Operator Phone',
      amount: 'Contract Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      signingTime: 'Signing Time',
      status: 'Status',
      parentContract: 'Parent Contract',
      room: 'Rooms',
      file: 'Attachments',
      fee: 'Contract Fees',
      hisFee: 'Payment History',
      roomFee: 'Room Fees',
      hisRoomFee: 'Room Payment History',
      ownerInfo: 'Owner Information',
      changeLog: 'Change Log',
      draftApproval: 'Draft Approval',
      subContract: 'Sub Contracts',
      receipt: 'Receipt Reprint'
    },
    contractDetailRoom: {
      addPropertyChange: 'Property Change',
      room: 'Room',
      floor: 'Floor',
      type: 'Type',
      area: 'Area',
      rent: 'Rent',
      roomStatus: 'Room Status',
      operation: 'Operation',
      businessAcceptance: 'Business Acceptance',
      contractArea: 'Contract Area',
      searchPlaceholder: 'Please enter room number like 1-1-1'
    },
    contractDetailFile: {
      relatedFiles: 'Related Files'
    },
    contractDetailFee: {
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      receivableAmount: 'Receivable Amount',
      accountingTime: 'Accounting Time',
      receivablePeriod: 'Receivable Period',
      description: 'Description',
      status: 'Status',
      operation: 'Operation',
      temporaryFee: 'Temporary Fee',
      createFee: 'Create Fee',
      payArrears: 'Pay Arrears',
      payment: 'Payment',
      paymentHistory: 'Payment History',
      cancel: 'Cancel',
      end: 'End',
      change: 'Change',
      previousReading: 'Previous Reading',
      currentReading: 'Current Reading',
      unitPrice: 'Unit Price',
      surcharge: 'Surcharge',
      usage: 'Usage',
      algorithm: 'Algorithm',
      fixedFee: 'Fixed Fee',
      feeBasedOnActual: 'Fee based on actual situation',
      note1: 'Note: "-" means not yet receivable or fee has ended',
      note2: 'Receivable amount -1 usually means formula error',
      arrearsSubtotal: 'Arrears Subtotal'
    },
    contractDetailHisFee: {
      feeItem: 'Fee Item',
      payer: 'Payer',
      cycle: 'Cycle(month)',
      receivableAmount: 'Receivable/Received(¥)',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      accountDeduction: 'Account Deduction'
    },
    contractDetailHisRoomFee: {
      feeItem: 'Fee Item',
      payerObject: 'Payer Object',
      cycle: 'Cycle (unit: month)',
      receivableAmount: 'Receivable/Received (unit: yuan)',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      accountDeduction: 'Account Deduction'
    },
   
    contractDetailFlow: {
      serialNumber: 'Serial Number',
      processor: 'Processor',
      status: 'Status',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion'
    },
    contractDetailSub: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      operator: 'Operator',
      contractAmount: 'Contract Amount',
      contractPartyB: 'Contract Party B',
      validityPeriod: 'Validity Period',
      draftTime: 'Draft Time',
      status: 'Status',
      operation: 'Operation',
      view: 'View'
    },
    contractDetailOwner: {
      ownerFace: 'Owner Face',
      name: 'Name',
      sex: 'Sex',
      idCard: 'ID Card',
      address: 'Address',
      roomCount: 'Room Count',
      memberCount: 'Member Count',
      carCount: 'Car Count',
      complaintCount: 'Complaint',
      repairCount: 'Repair',
      oweFee: 'Owe Fee',
      contractCount: 'Contract'
    },
    contractDetailReceipt: {
      feeType: 'Fee Type',
      owner: 'Owner',
      feeItem: 'Fee Item',
      feePeriod: 'Fee Period',
      totalAmount: 'Total Amount',
      payTime: 'Pay Time',
      receiptId: 'Receipt ID',
      print: 'Print',
      printSmall: 'Print Small',
      printApply: 'Apply',
      selectPrintReceipt: 'Please select receipt to print',
      selectPrint: 'Please select'
    },
  },
  zh: {
    contractDetail: {
      title: '合同信息',
      contractName: '合同名称',
      contractCode: '合同编号',
      contractType: '合同类型',
      partyA: '甲方',
      partyB: '乙方',
      aContacts: '甲方联系人',
      bContacts: '乙方联系人',
      aLink: '甲方联系电话',
      bLink: '乙方联系电话',
      operator: '经办人',
      operatorLink: '联系电话',
      amount: '合同金额',
      startTime: '开始时间',
      endTime: '结束时间',
      signingTime: '签订时间',
      status: '状态',
      parentContract: '父合同',
      room: '房屋',
      file: '附件',
      fee: '合同费用',
      hisFee: '合同缴费记录',
      roomFee: '房屋费用',
      hisRoomFee: '房屋缴费记录',
      ownerInfo: '业主信息',
      changeLog: '变更记录',
      draftApproval: '起草审批',
      subContract: '子合同',
      receipt: '补打收据'
    },
    contractDetailRoom: {
      addPropertyChange: '房产变更',
      room: '房屋',
      floor: '楼层',
      type: '类型',
      area: '面积',
      rent: '租金',
      roomStatus: '房屋状态',
      operation: '操作',
      businessAcceptance: '业务受理',
      contractArea: '合同面积',
      searchPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1'
    },
    contractDetailFile: {
      relatedFiles: '相关附件'
    },
    contractDetailFee: {
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      receivableAmount: '应收金额',
      accountingTime: '建账时间',
      receivablePeriod: '应收时间段',
      description: '说明',
      status: '状态',
      operation: '操作',
      temporaryFee: '临时收费',
      createFee: '创建费用',
      payArrears: '欠费缴费',
      payment: '缴费',
      paymentHistory: '缴费历史',
      cancel: '取消',
      end: '结束',
      change: '变更',
      previousReading: '上期度数',
      currentReading: '本期度数',
      unitPrice: '单价',
      surcharge: '附加费',
      usage: '用量',
      algorithm: '算法',
      fixedFee: '固定费',
      feeBasedOnActual: '费用根据实际情况而定',
      note1: '注意：应收结束时间 "-" 表示未到应收时间或收费已结束',
      note2: '应收金额为-1一般为费用项公式设置出错请检查',
      arrearsSubtotal: '欠费小计'
    },
    contractDetailHisFee: {
      feeItem: '费用项',
      payer: '收费对象',
      cycle: '周期(单位:月)',
      receivableAmount: '应收/实收(单位:元)',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      accountDeduction: '账户扣款'
    },
    contractDetailHisRoomFee: {
      feeItem: '费用项',
      payerObject: '收费对象',
      cycle: '周期(单位:月)',
      receivableAmount: '应收/实收(单位:元)',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      accountDeduction: '账户扣款'
    },
   
    contractDetailFlow: {
      serialNumber: '序号',
      processor: '处理人',
      status: '状态',
      processTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见'
    },
    contractDetailSub: {
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      operator: '经办人',
      contractAmount: '合同金额',
      contractPartyB: '合同乙方',
      validityPeriod: '有效期',
      draftTime: '起草时间',
      status: '状态',
      operation: '操作',
      view: '查看'
    },
    contractDetailOwner: {
      ownerFace: '业主人脸',
      name: '姓名',
      sex: '性别',
      idCard: '身份证',
      address: '家庭住址',
      roomCount: '房屋数',
      memberCount: '业主成员',
      carCount: '车辆数',
      complaintCount: '投诉',
      repairCount: '报修',
      oweFee: '欠费',
      contractCount: '业主合同'
    },
contractDetailReceipt: {
      feeType: '费用类型',
      owner: '业主',
      feeItem: '费用项目',
      feePeriod: '收费时间段',
      totalAmount: '总金额',
      payTime: '缴费时间',
      receiptId: '收据ID',
      print: '打印',
      printSmall: '打印小票',
      printApply: '申请单',
      selectPrintReceipt: '请选择打印收据',
      selectPrint: '请选择'
    },
  },
  'zh-TW': {
    contractDetail: {
      title: '合同信息',
      contractName: '合同名稱',
      contractCode: '合同編號',
      contractType: '合同類型',
      partyA: '甲方',
      partyB: '乙方',
      aContacts: '甲方聯絡人',
      bContacts: '乙方聯絡人',
      aLink: '甲方聯繫電話',
      bLink: '乙方聯繫電話',
      operator: '經辦人',
      operatorLink: '聯繫電話',
      amount: '合同金額',
      startTime: '開始時間',
      endTime: '結束時間',
      signingTime: '簽訂時間',
      status: '狀態',
      parentContract: '父合同',
      room: '房屋',
      file: '附件',
      fee: '合同費用',
      hisFee: '合同繳費記錄',
      roomFee: '房屋費用',
      hisRoomFee: '房屋繳費記錄',
      ownerInfo: '業主信息',
      changeLog: '變更記錄',
      draftApproval: '起草審批',
      subContract: '子合同',
      receipt: '補打收據'
    },
    contractDetailRoom: {
      addPropertyChange: '房產變更',
      room: '房屋',
      floor: '樓層',
      type: '類型',
      area: '面積',
      rent: '租金',
      roomStatus: '房屋狀態',
      operation: '操作',
      businessAcceptance: '業務受理',
      contractArea: '合同面積',
      searchPlaceholder: '請輸入房屋編號 樓棟-單元-房屋 如1-1-1'
    },
    contractDetailFile: {
      relatedFiles: '相關附件'
    },
    contractDetailFee: {
      feeItem: '費用項目',
      feeFlag: '費用標識',
      feeType: '費用類型',
      receivableAmount: '應收金額',
      accountingTime: '建帳時間',
      receivablePeriod: '應收時間段',
      description: '說明',
      status: '狀態',
      operation: '操作',
      temporaryFee: '臨時收費',
      createFee: '創建費用',
      payArrears: '欠費繳費',
      payment: '繳費',
      paymentHistory: '繳費歷史',
      cancel: '取消',
      end: '結束',
      change: '變更',
      previousReading: '上期度數',
      currentReading: '本期度數',
      unitPrice: '單價',
      surcharge: '附加費',
      usage: '用量',
      algorithm: '算法',
      fixedFee: '固定費',
      feeBasedOnActual: '費用根據實際情況而定',
      note1: '注意：應收結束時間 "-" 表示未到應收時間或收費已結束',
      note2: '應收金額為-1一般為費用項公式設置出錯請檢查',
      arrearsSubtotal: '欠費小計'
    },
    contractDetailHisFee: {
      feeItem: '費用項',
      payer: '收費對象',
      cycle: '週期(單位:月)',
      receivableAmount: '應收/實收(單位:元)',
      paymentMethod: '繳費方式',
      paymentPeriod: '繳費起始段',
      paymentTime: '繳費時間',
      cashier: '收銀員',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      detail: '詳情',
      accountDeduction: '帳戶扣款'
    },
    contractDetailHisRoomFee: {
      feeItem: '費用項',
      payerObject: '收費對象',
      cycle: '週期(單位:月)',
      receivableAmount: '應收/實收(單位:元)',
      paymentMethod: '繳費方式',
      paymentPeriod: '繳費起始段',
      paymentTime: '繳費時間',
      cashier: '收銀員',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      detail: '詳情',
      accountDeduction: '帳戶扣款'
    },
    contractDetailFlow: {
      serialNumber: '序號',
      processor: '處理人',
      status: '狀態',
      processTime: '處理時間',
      timeConsuming: '耗時',
      opinion: '意見'
    },
    contractDetailSub: {
      contractName: '合同名稱',
      contractCode: '合同編號',
      parentContractCode: '父合同編號',
      contractType: '合同類型',
      operator: '經辦人',
      contractAmount: '合同金額',
      contractPartyB: '合同乙方',
      validityPeriod: '有效期',
      draftTime: '起草時間',
      status: '狀態',
      operation: '操作',
      view: '查看'
    },
    contractDetailOwner: {
      ownerFace: '業主人臉',
      name: '姓名',
      sex: '性別',
      idCard: '身份證',
      address: '家庭住址',
      roomCount: '房屋數',
      memberCount: '業主成員',
      carCount: '車輛數',
      complaintCount: '投訴',
      repairCount: '報修',
      oweFee: '欠費',
      contractCount: '業主合同'
    },
    contractDetailReceipt: {
      feeType: '費用類型',
      owner: '業主',
      feeItem: '費用項目',
      feePeriod: '收費時間段',
      totalAmount: '總金額',
      payTime: '繳費時間',
      receiptId: '收據ID',
      print: '列印',
      printSmall: '列印小票',
      printApply: '申請單',
      selectPrintReceipt: '請選擇列印收據',
      selectPrint: '請選擇'
    },
  }
}